import { getters } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export default {
  currentStep: state => state.currentStep,
  steps: state => state.hasHierarchy ? state.steps : state.steps.filter(step => step !== "Hierarquia"),
  stepsNamesRoutes: state => state.hasHierarchy
    ? state.stepsNamesRoutes
    : state.stepsNamesRoutes.filter(route => route !== "user-hierarchy"),
  hasHierarchy: state => state.hasHierarchy,
  routeAfterAccessSteps: state => state.hasHierarchy ? "user-hierarchy" : "user-leadership",
  chainsAccess: state => state.chainsAccess,
  selectedChains: state => state.selectedChains,
  selectedPos: state => state.selectedPos,
  uuid: state => state.uuid,
  loading: state => state.loading,
  isEditing: state => state.isEditing,
  getPosOptions: state => state.posOptions,
  getRolesOptions: state => state.rolesOptions,
  getChainsOptions: state => state.chainsOptions,
  payloadUsers: state => {
    return {
      active: state.active,
      name: state.name,
      username: state.username,
      cpf: state.cpf,
      birthdate: state.birthdate,
      email: state.email,
      photo: state.photo,
      role: state.role,
      roleCategory: state.roleCategory,
      pos: state.pos,
      favoritePos: state.favoritePos,
      all_chains: state.all_chains,
      chains: state.chains,
      providers: state.providers,
      states: state.states,
      leaders: state.leaders,
      led: state.led,
      superior: state.superior,
      superiorChain: state.superiorChain,
      phone: state.phone,
      gender: state.gender,
      isAdmin: state.isAdmin,
      addresses: [state.address]
    }
  },
  ...getters
}
